export const RuFlag = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.9999 10.0107H0.000138552L0 10C0 4.47707 4.47703 0 10 0C15.5228 0 20 4.47707 20 10L19.9999 10.0107Z"
        fill="white"
      />
      <path
        d="M0.0001297 10.0107H19.9999C19.9941 15.5286 15.5193 20.0001 9.99999 20.0001C4.48058 20.0001 0.00585964 15.5286 0.0001297 10.0107Z"
        fill="#D52B1E"
      />
      <path
        d="M0.57502 6.6521H19.425C19.7969 7.69883 20 8.8256 20 10C20 11.1823 19.7943 12.3165 19.4175 13.3693H0.582506C0.205716 12.3165 -7.62939e-06 11.1823 -7.62939e-06 10C-7.62939e-06 8.8256 0.203128 7.69883 0.57502 6.6521Z"
        fill="#0039A6"
      />
    </svg>
  );
};
